import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AgGridPagingPanelComponent } from './paging-panel.component';
import { StrakitButtonComponent, StrakitNumberComponent, StrakitSelectComponent } from '@ngx-strakit/cdk/controls';
import {
  StrakitToolbarComponent,
  StrakitToolbarContentLeftDirective,
  StrakitToolbarContentRightDirective,
} from '@ngx-strakit/cdk/layout';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    StrakitNumberComponent,
    StrakitSelectComponent,
    StrakitToolbarComponent,
    StrakitToolbarContentLeftDirective,
    StrakitToolbarContentRightDirective,
    StrakitButtonComponent,
  ],
  declarations: [AgGridPagingPanelComponent],
  exports: [AgGridPagingPanelComponent],
})
export class AgGridPagingPanelComponentModule { }
